import React from "react";
import StyledSelect from "../../components/StyledSelect";
import { styles } from "./leadsStyles";

export function LeadsConversionTab({ vm }) {
  const {
    activeTab,
    conversionStatusSummary,
    conversionMessage,
    conversionStatus,
    conversionMetaPixelId,
    setConversionMetaPixelId,
    conversionMetaAccessToken,
    setConversionMetaAccessToken,
    conversionMetaTestEventCode,
    setConversionMetaTestEventCode,
    hasSavedMetaAccessToken,
    setMetaFieldsTouched,
    conversionGatewayEnabled,
    setConversionGatewayEnabled,
    conversionModeLead,
    setConversionModeLead,
    conversionModeAddToCart,
    setConversionModeAddToCart,
    conversionModePurchase,
    setConversionModePurchase,
    conversionGa4MeasurementId,
    setConversionGa4MeasurementId,
    conversionGa4ApiSecret,
    setConversionGa4ApiSecret,
    hasSavedGa4ApiSecret,
    conversionGoogleCustomerId,
    setConversionGoogleCustomerId,
    conversionGoogleActionId,
    setConversionGoogleActionId,
    conversionGoogleSendTo,
    setConversionGoogleSendTo,
    saveConversionConfig,
  } = vm;
  return (
    <>
      {false && activeTab === "conversion" && (
              <div>
                <h3 style={styles.sectionTitle}>Atribuição de leads (Meta e Google Ads)</h3>
                <input type="text" name="fake_username" autoComplete="username" style={{ display: "none" }} />
                <input type="password" name="fake_password" autoComplete="current-password" style={{ display: "none" }} />
                <p style={styles.helperText}>
                  O widget dispara no navegador os eventos <strong>Lead</strong> (Meta) e <strong>generate_lead</strong> (Google), além do dataLayer <strong>tilti_lead</strong> para GTM. Se você já usa GTM (navegador + servidor) e envia conversões por conta própria, não precisa preencher Token nem Customer ID/Conversion Action abaixo — só use <strong>send_to</strong> se quiser que o widget dispare o gtag diretamente.
                </p>
                {conversionStatusSummary && (
                  <div style={styles.message}>
                    <strong>Últimas 24h:</strong>{" "}
                    {(conversionStatusSummary.totals || []).map(item => `${item._id}: ${item.count}`).join(" | ") || "sem eventos"}
                  </div>
                )}
                {conversionMessage && (
                  <div style={{
                    ...styles.message,
                    ...(conversionStatus === "success" ? styles.messageSuccess : styles.messageError)
                  }}>
                    {conversionMessage}
                  </div>
                )}
                <div style={styles.formGroup}>
                  <label style={styles.label}>Meta: Pixel ID</label>
                  <input
                    type="text"
                    name="meta_pixel_id_config"
                    autoComplete="off"
                    value={conversionMetaPixelId}
                    onChange={(e) => {
                      setConversionMetaPixelId(e.target.value);
                      setMetaFieldsTouched(true);
                    }}
                    placeholder="Ex: 123456789012345"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Opcional para envio server-side. Se a Tilti for enviar a conversão ao Meta no servidor, informe o Pixel ID.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Meta: Access Token (Conversions API)</label>
                  <input
                    type="password"
                    name="meta_conversion_access_token_config"
                    autoComplete="new-password"
                    value={conversionMetaAccessToken}
                    onChange={(e) => {
                      setConversionMetaAccessToken(e.target.value);
                      setMetaFieldsTouched(true);
                    }}
                    placeholder="Token de acesso do pixel"
                    style={styles.input}
                  />
                  {hasSavedMetaAccessToken && (
                    <p style={styles.helperText}>Já existe um Access Token salvo no servidor.</p>
                  )}
                  <p style={styles.helperText}>Opcional. Preencha somente se a Tilti for enviar a conversão ao Meta no servidor. Se você usa GTM server-side (ou outra API de conversões) e já envia o evento Lead, deixe em branco.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Meta: Test Event Code</label>
                  <input
                    type="text"
                    name="meta_test_event_code_config"
                    autoComplete="off"
                    value={conversionMetaTestEventCode}
                    onChange={(e) => {
                      setConversionMetaTestEventCode(e.target.value);
                      setMetaFieldsTouched(true);
                    }}
                    placeholder="Ex: TEST12345 (opcional — para aparecer em Test Events do Meta)"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Opcional. Cole o código gerado no Events Manager (Test Events) para ver os eventos server-side em tempo real nos testes.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Gateway de conversão Tilti (sem Stape)</label>
                  <StyledSelect
                    value={conversionGatewayEnabled ? "enabled" : "disabled"}
                    onChange={(v) => setConversionGatewayEnabled(v === "enabled")}
                    options={[
                      { value: "enabled", label: "Ativado" },
                      { value: "disabled", label: "Desativado" }
                    ]}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Modo do evento Lead</label>
                  <StyledSelect
                    value={conversionModeLead}
                    onChange={setConversionModeLead}
                    options={[
                      { value: "server_only", label: "server_only" },
                      { value: "hybrid", label: "hybrid" },
                      { value: "browser_only", label: "browser_only" }
                    ]}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Modo do evento AddToCart</label>
                  <StyledSelect
                    value={conversionModeAddToCart}
                    onChange={setConversionModeAddToCart}
                    options={[
                      { value: "server_only", label: "server_only" },
                      { value: "hybrid", label: "hybrid" },
                      { value: "browser_only", label: "browser_only" }
                    ]}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Modo do evento Purchase</label>
                  <StyledSelect
                    value={conversionModePurchase}
                    onChange={setConversionModePurchase}
                    options={[
                      { value: "server_only", label: "server_only" },
                      { value: "hybrid", label: "hybrid" },
                      { value: "browser_only", label: "browser_only" }
                    ]}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>GA4: Measurement ID</label>
                  <input
                    type="text"
                    value={conversionGa4MeasurementId}
                    onChange={(e) => setConversionGa4MeasurementId(e.target.value)}
                    placeholder="Ex: G-XXXXXXXXXX"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Obrigatório para envio server-side para Google Analytics 4.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>GA4: API Secret</label>
                  <input
                    type="password"
                    value={conversionGa4ApiSecret}
                    onChange={(e) => setConversionGa4ApiSecret(e.target.value)}
                    placeholder="API Secret do Measurement Protocol"
                    style={styles.input}
                  />
                  {hasSavedGa4ApiSecret && (
                    <p style={styles.helperText}>Já existe um API Secret salvo no servidor.</p>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Google Ads: Customer ID</label>
                  <input
                    type="text"
                    value={conversionGoogleCustomerId}
                    onChange={(e) => setConversionGoogleCustomerId(e.target.value)}
                    placeholder="Ex: 123-456-7890"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Opcional para envio server-side. Só necessário se a Tilti for enviar a conversão offline ao Google Ads. Se você usa GTM/gtag no navegador, pode deixar em branco.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Google Ads: Conversion Action ID</label>
                  <input
                    type="text"
                    value={conversionGoogleActionId}
                    onChange={(e) => setConversionGoogleActionId(e.target.value)}
                    placeholder="ID da ação de conversão"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Opcional para envio server-side. Usado junto com Customer ID quando a Tilti envia a conversão ao Google.</p>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Google: send_to (para gtag no navegador)</label>
                  <input
                    type="text"
                    value={conversionGoogleSendTo}
                    onChange={(e) => setConversionGoogleSendTo(e.target.value)}
                    placeholder="Ex: AW-123456789/AbCdEfGh"
                    style={styles.input}
                  />
                  <p style={styles.helperText}>Se preenchido, o widget dispara gtag('event', 'generate_lead', &#123; send_to: ... &#125;) no navegador. Também dispara dataLayer.push(&#123; event: 'tilti_lead' &#125;) para uso no GTM.</p>
                </div>
                <div style={styles.buttonGroup}>
                  <button onClick={saveConversionConfig} style={styles.button}>
                    Salvar configuração
                  </button>
                </div>
              </div>
      )}
    </>
  );
}
